import { render, staticRenderFns } from "./DataRecordEditForm.vue?vue&type=template&id=c9814dda&scoped=true&"
import script from "./DataRecordEditForm.vue?vue&type=script&lang=js&"
export * from "./DataRecordEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordEditForm.vue?vue&type=style&index=0&id=c9814dda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9814dda",
  null
  
)

export default component.exports